import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import Vue3VideoPlayer from '@cloudgeek/vue3-video-player'
import '@cloudgeek/vue3-video-player/dist/vue3-video-player.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'animate.css'
import LazyImage from '@/components/LazyImage.vue'
import AppUpload from '@/components/AppUpload.vue'
const app = createApp(App)
app.component('LazyImage', LazyImage)
app.component('AppUpload', AppUpload)
app.use(store).use(router).use(ElementPlus, {locale: zhCn}).use(Vue3VideoPlayer, {lang: 'zh-CN'}).mount('#app')
